import React from "react";
import { Cpu, ShieldCheck, Cloud, Server, Wifi, Database, Network, Mail } from "lucide-react";

const logos = [
  { Icon: Cpu, label: "Windows" },
  { Icon: Cloud, label: "Azure" },
  { Icon: Mail, label: "Microsoft 365" },
  { Icon: ShieldCheck, label: "CyberEssentials" },
  { Icon: Server, label: "VMware" },
  { Icon: Wifi, label: "Ubiquiti" },
  { Icon: Database, label: "Veeam" },
  { Icon: Network, label: "Cisco" },
];

const LogoMarquee = () => {
  const row = [...logos, ...logos];
  return (
    <section className="relative py-14 bg-[#05070d] border-y border-white/5 overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <p className="text-center text-xs tracking-[0.35em] text-white/45 font-semibold mb-6">
          TRUSTED TOOLS · CERTIFIED PARTNERS
        </p>
      </div>

      <div className="relative">
        <div className="absolute left-0 top-0 bottom-0 w-24 md:w-40 bg-gradient-to-r from-[#05070d] to-transparent z-10 pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-24 md:w-40 bg-gradient-to-l from-[#05070d] to-transparent z-10 pointer-events-none" />
        <div className="marquee-track flex items-center gap-14 whitespace-nowrap w-max">
          {row.map(({ Icon, label }, i) => (
            <div key={i} className="flex items-center gap-3 text-white/60 hover:text-white transition-colors">
              <Icon className="w-5 h-5" />
              <span className="text-sm font-medium tracking-wide">{label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LogoMarquee;
